import { ChangeEvent } from "react";
import { InputProps, Inputs } from "..";

interface InputTextProps extends InputProps {
  max?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const InputText = (props: InputTextProps) => {
  return (
    <Inputs
      label={props.label ? props.label : undefined}
      width={props.width}
      size={props.size}
      required={props.required ? props.required : false}
    >
      <input
        type="text"
        autoCapitalize="none"
        id={props.id && props.id}
        name={props.name}
        placeholder={props.placeholder && props.placeholder}
        onChange={props.onChange}
        defaultValue={props.defaultValue}
        disabled={props.disabled}
        max={props.max}
        tabIndex={props.tabIndex}
      />
    </Inputs>
  );
};
